<template>
  <div class="wrapper">
    <div
      v-if="windowWidth > 1263"
      :class="{
        videos: true,
        'videos-wrapper-skeleton-loader': isSkeletonLoader,
      }"
    >
      <slot />
    </div>
    <DragScroll :itemsToShow="4.5" :isSkeletonLoader="isSkeletonLoader" v-else>
      <slot />
    </DragScroll>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DragScroll from '../carousel/DragScroll.vue';

export default {
  name: 'VideosWrapper',
  props: {
    isSkeletonLoader: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DragScroll,
  },
  computed: {
    ...mapGetters(['windowWidth']),
  },
};
</script>

<style lang="scss" scoped>
.videos {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: white;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  max-height: 902px;
  height: 902px;
  overflow: hidden;
}
.videos::-webkit-scrollbar {
  display: block;
  width: 10px;
}
.videos::-webkit-scrollbar-track {
  background-color: #e5e8ed;
  border-radius: 4px;
}

.videos::-webkit-scrollbar-thumb {
  background-color: #e5e8ed;
  border-left: 2px white solid;
  border-right: 2px white solid;
  background-color: #234025;
  border-radius: 4px;
  height: 12px;
}
.videos::-webkit-scrollbar-button {
  height: 12px;
}
.videos::-webkit-scrollbar-track-piece:end {
  background: transparent;
  margin-bottom: 10px;
}

.videos::-webkit-scrollbar-track-piece:start {
  background: transparent;
  margin-top: 10px;
}

.videos:hover {
  overflow: auto;
}
// .videos::-webkit-scrollbar {
//   width: 10px;
// }

// .videos::-webkit-scrollbar-track {
//   background: #E5E8ED;
//   border-left: 2px white solid;
//   border-right: 2px white solid;
// }

// .videos::-webkit-scrollbar-thumb {
//   width: 10px;
//   height: 48px;
//   background-color: #234025;
//   border-radius: 100px;
//   border-left: 2px white solid;
//   border-right: 2px white solid;
// }

.videos-wrapper-skeleton-loader {
  max-height: none;
  height: 900px;
}
@media (max-width: 1263px) {
  .wrapper {
    height: 100%;
    margin-bottom: 32px;
  }
}
</style>
